import { useEffect, useState } from "react";
import { NEWS_ITEMS } from "../data/constants";
import { C } from "../theme/colors";
import Divider from "./Divider";

const NEWS_API_URL = "https://ccapi.rapifuzz.in:8443/api/news-list/";

export default function NewsSection() {
  const [expandedNews, setExpandedNews] = useState(null);
  const [apiNews, setApiNews] = useState(null);

  useEffect(() => {
    let cancelled = false;

    fetch(NEWS_API_URL)
      .then(res => {
        if (!res.ok) throw new Error(`Request failed (${res.status})`);
        return res.json();
      })
      .then(json => {
        if (cancelled) return;
        const list = Array.isArray(json?.data) ? json.data : [];
        if (list.length) {
          setApiNews(list.map(n => ({
            date: n.publish_date,
            title: n.title,
            desc: n.description,
          })));
        }
      })
      .catch(() => {
        // Silently keep the static fallback list on any failure
      });

    return () => { cancelled = true; };
  }, []);

  const newsItems = apiNews && apiNews.length ? apiNews : NEWS_ITEMS;

  return (
    <div style={{background:C.white,padding:"80px 40px"}}>
      <div style={{maxWidth:1260,margin:"0 auto"}}>
        <span className="section-tag">Latest Updates</span>
        <h2 style={{fontFamily:"Arial,Helvetica,sans-serif",fontWeight:600,color:C.navyDark,fontSize:"clamp(1.5rem,2.5vw,2.2rem)",marginTop:10}}>News & Announcements</h2>
        <Divider/>
        <div style={{background:C.white,borderRadius:14,border:`1px solid ${C.border}`,overflow:"hidden"}}>
          {newsItems.map((item, i) => (
            <div key={i} style={{borderBottom: i < newsItems.length - 1 ? `1px solid ${C.border}` : "none"}}>
              <div style={{display:"flex",alignItems:"center",gap:14,padding:"18px 28px",cursor:"pointer",userSelect:"none",background:expandedNews===i?C.bgAlt:C.white,transition:"background .2s"}} onClick={() => setExpandedNews(expandedNews === i ? null : i)}>
                <span style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:11.5,fontWeight:700,color:C.blue,background:C.accent,padding:"4px 10px",borderRadius:20,whiteSpace:"nowrap",flexShrink:0}}>{item.date}</span>
                <span style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:14,fontWeight:600,color:C.navyDark,flex:1,lineHeight:1.5}}>{item.title}</span>
                <span style={{color:C.textMuted,fontSize:14,transition:"transform .25s",display:"inline-block",transform:expandedNews===i?"rotate(180deg)":"rotate(0deg)"}}>▾</span>
              </div>
              {expandedNews === i && (
                <div
                  style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:13.5,color:C.textMid,lineHeight:1.75,padding:"0 28px 20px",margin:0}}
                  dangerouslySetInnerHTML={{__html: item.desc}}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}